export default __webpack_public_path__ + "zth-dashboard-alert-b8d497.mp3";